import { useEffect, useState } from 'react';
import useGetRequest from '../../hooks/useGetRequest';
import { CSVLink } from "react-csv";
import userDataHeaders from '../../helpers/userDataHeaders'

const UsersData = () => {
    const [loading, setLoading] = useState(false);
    const [listOfIpmPlans, setListOfIpmPlans] = useState([]);
    const [includeExcludedAnalysisRecords, setIncludeExcludedAnalysisRecords] =
        useState(false);

    const endpoint = `/api/admin/users-data?includeExcludedAnalysisRecords=${includeExcludedAnalysisRecords}`;

    const { get } = useGetRequest(endpoint);

    useEffect(() => {
        handleDataFetch();
    }, [includeExcludedAnalysisRecords])



    const headers = userDataHeaders;

    const handleDataFetch = async () => {
        setLoading(true);

        try {
            const data = await get();
            if (data !== undefined) {
                setListOfIpmPlans(data);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <h3 className='mt-4'>Get Users Data</h3>
            <div className="form-check mb-3">
                <input
                    id="includeExcludedAnalysisRecords"
                    type="checkbox"
                    className="form-check-input"
                    checked={includeExcludedAnalysisRecords}
                    onChange={(event) =>
                        setIncludeExcludedAnalysisRecords(
                            event.target.checked
                        )
                    }
                    disabled={loading}
                />

                <label
                    htmlFor="includeExcludedAnalysisRecords"
                    className="form-check-label"
                >
                    Include records excluded from analysis
                </label>
            </div>
            <CSVLink
                data={listOfIpmPlans}
                headers={headers}
                filename={`ipmToolUserData_${new Date().toLocaleString()}.csv`}
                className={`btn btn-primary ${loading ? 'disabled' : ''}`}
                target="_blank"
                aria-disabled={loading}
                tabIndex={loading ? -1 : 0}
                onClick={(event) => {
                    if (loading) {
                        event.preventDefault();
                    }
                }}
            >
                {loading ? 'Loading csv...' : 'Download User Data'}
            </CSVLink>
        </>
    );
};

export default UsersData;